import React from 'react'
import {FreeNextDay} from '../../../components/book-delivery/free-next-day'
import {Box, Button, Flex, Text} from '../../../vanilla'
import {DeliveryMapWithPinIcon} from '../../../components/icons'
import useNavigation from '../../../hooks/use-navigation'

interface DeliveryInitialProps {
  deliveryPostalCode?: string
}

const DeliveryInitial = ({deliveryPostalCode}: DeliveryInitialProps) => {
  const navigate = useNavigation()

  return (
    <Box>
      <FreeNextDay />
      {deliveryPostalCode && (
        <Flex bg="gray50" gap="20px" padding="20px" alignItems="center" marginY="20px">
          <Box>
            <DeliveryMapWithPinIcon color="accent0" boxSize="56px" />
          </Box>
          <Text variant="text4" data-cs-mask="">
            <Text as="span" data-test-selector="delivery-available-message">
              {`Great news! We'll deliver your shop to ${deliveryPostalCode}!`}
            </Text>{' '}
            <Text
              variant="text4"
              padding="0px"
              textDecoration="underline"
              color="accent5"
              lineHeight="short"
              data-test-selector="change-postcode"
              cursor="pointer"
              onClick={() => {
                navigate('/book-delivery', 'push', {
                  redirectTo: '/basket',
                })
              }}
              marginLeft="4px"
            >
              Change postcode
            </Text>
          </Text>
        </Flex>
      )}

      <Button
        size="sm"
        data-test-selector="book-delivery-link"
        variant="primary"
        onClick={() => {
          navigate('/book-delivery', 'push', {
            redirectTo: '/basket',
          })
        }}
      >
        <Text variant="unstyled" fontSize="inherit" fontWeight="inherit" color="white">
          Book Delivery
        </Text>
      </Button>
    </Box>
  )
}

export default DeliveryInitial
